<div class="secure-key-administration">

  <sc-master-detail [selection]="[selectedSecureKey]" [data]="secureKeys" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <form class="form" [formGroup]="formGroup">
        <sc-padding>
          <sc-flex [vertical]="true" [stretchContent]="true" *ngIf="secureKeyDetails" class="no-field-space">
            <sc-read-only-field
              [label]="'consecutive number' | translate: ['tmc-common.entity.secure-key.consecutive-number', translationService.language]"
              [value]="secureKeyDetails.consecutiveNumber != null ? secureKeyDetails.consecutiveNumber + '' : ''">
            </sc-read-only-field>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <sc-read-only-field
              [label]="'hash code' | translate: ['tmc-common.entity.secure-key.hash-code', translationService.language]"
              [value]="secureKeyDetails.hashCode != null ? secureKeyDetails.hashCode + '' : ''">
            </sc-read-only-field>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <sc-string-field [grow]="true" formControlName="usage"
              [label]="'usage' | translate: ['tmc-common.entity.secure-key.usage', translationService.language]">
            </sc-string-field>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-checkbox formControlName="active" name="active">
              {{'active' | translate: ['tmc-common.entity.secure-key.active', translationService.language]}}
            </mat-checkbox>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-title>
              {{'area gates' | translate: ['tmc-yard.widget.secure-key-administration.area-gates.title',
              translationService.language]}}
            </sc-title>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <div class="area-gates">
              <ng-container *ngFor="let areaGate of secureKeyDetails.areaGateAssignments">
                <div class="area-gate" *ngIf="!areaGate.deleted">
                  <sc-flex>
                    <sc-read-only-field style="flex-grow: 1;"
                      [label]="'area gate' | translate: ['tmc-common.entity.area-gate.name', translationService.language]"
                      [value]="areaGate.areaGateName">
                    </sc-read-only-field>
                    <sc-content-spacer [vertical]="false"></sc-content-spacer>
                    <div class="delete-button">
                      <sc-icon iconClass="fa-trash" (click)="removeAreaGateAssignment(areaGate)"></sc-icon>
                    </div>
                  </sc-flex>
                </div>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
              </ng-container>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <button class="add-button" mat-flat-button type="button" (click)="addAreaGateAssignment()">
                <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
              </button>

            </div>

          </sc-flex>
        </sc-padding>
      </form>

    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled">{{'cancel'
        | translate: ['tmc-yard.widget.secure-key-administration.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
        translate: ['tmc-yard.widget.secure-key-administration.action.save',
        translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>

</div>
